<template>
  <div class="map-widget-ad-metrix">
    <LinceWidgetAdMetrix
      :adMetrix="adMetrixProxy"
      @close="close"
      @calculate="calculate"
      @download="download"
    />

    <RealtimeSystemEspar @esparCalculated="calculateSocket"/>
  </div>
</template>

<script>
import RealtimeSystemEspar from "@/components/RealtimeSystem/RealtimeSystemEspar.vue";
import ServiceWidgetAdMetrix from '@/services/ServicesWidgetsMap/ServiceWidgetAdMetrix.js';

export default {
  name: "MapWidgetAdMetrix",
  components: { RealtimeSystemEspar },
  props: {
    adMetrix: {
      type: Array,
      default: () => ([])
    }
  },
  data: () => ({
    adMetrixProxy: []
  }),
  watch: {
    adMetrix() {
      this.adMetrixProxy = this.adMetrixProxy.filter(adMetrixProxyItem => this.adMetrix.some(adMetrixItem => adMetrixProxyItem.id === adMetrixItem.id));
      
      const adMetrixNew = this.adMetrix.filter(adMetrixItem => !this.adMetrixProxy.some(adMetrixProxyItem => adMetrixProxyItem.id === adMetrixItem.id));
      this.adMetrixProxy.push(...adMetrixNew);
    }
  },
  methods: {
    close(adMetrixItemId = "") {
      this.$emit("closeAdMetrix", adMetrixItemId);
    },
    async calculate(adMetrixItemId = "", countDays = 0) {
      const adMetrixItemIndex = this.adMetrixProxy.findIndex(adMetrixProxyItem => adMetrixProxyItem.id === adMetrixItemId);

      this.adMetrixProxy.splice(adMetrixItemIndex, 1, { ...this.adMetrixProxy[adMetrixItemIndex], isLoading: true });

      try {
        const adMetrixData = await ServiceWidgetAdMetrix.getAdMetrixKit(adMetrixItemId, countDays);

        this.adMetrixProxy.splice(adMetrixItemIndex, 1, { ...this.adMetrixProxy[adMetrixItemIndex], ...adMetrixData, isLoading: false });
      } catch (error) {
        this.adMetrixProxy.splice(adMetrixItemIndex, 1, { ...this.adMetrixProxy[adMetrixItemIndex], params: {}, error, isLoading: false });
      }
    },
    calculateSocket(adMetrixDataBefore = {}) {
      const adMetrixData = ServiceWidgetAdMetrix.getAdMetrixKitAfter({ data: { data: adMetrixDataBefore?.data?.result ?? {} } });
      const adMetrixItemIndex = this.adMetrixProxy.findIndex(adMetrixProxyItem => adMetrixProxyItem.exportKey === adMetrixData.exportKey);

      this.adMetrixProxy.splice(adMetrixItemIndex, 1, { ...this.adMetrixProxy[adMetrixItemIndex], ...adMetrixData, error: "" });
    },
    async download(exportKey = "") {
      try {
        const fileBlobData = await ServiceWidgetAdMetrix.downloadAdMetrix(exportKey);
        const fileUrl = window.URL.createObjectURL(fileBlobData);

        window.open(fileUrl, '_blank');
      } catch (error) {
        this.$notify.addNotification({
          type: "error",
          title: "Ошибка экспорта",
          description: error,
          duration: Infinity,
          position: 'bottom-right'
        });
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  .map-widget-ad-metrix {
    display: inline-flex;
    float: left;
  }
</style>